<template>
  <a
    v-if="link"
    :href="link"
    :class="[
      'button',
      { 'button--round': round },
      { 'button--red': red },
      { 'button--white': white },
      { 'button--disabled': disabled },
      { 'button--large': large },
      { 'button--full': full },
      { 'button--icon': icon },
      { 'button--overlay': overlay },
      { 'button--border': border },
      { 'button--simple': simple }
    ]"
  ><span>
    <slot />
    <span
      v-if="text"
      class="button__text"
    >
      {{ text }}
    </span>
  </span>
  </a>

  <router-link
    v-else-if="route"
    :to="route"
    :class="[
      'button',
      { 'button--round': round },
      { 'button--red': red },
      { 'button--white': white },
      { 'button--disabled': disabled },
      { 'button--large': large },
      { 'button--full': full },
      { 'button--icon': icon },
      { 'button--overlay': overlay },
      { 'button--border': border },
      { 'button--simple': simple }
    ]"
  >
    <span>
      <slot />
      <span
        v-if="text"
        class="button__text"
      >
        {{ text }}
      </span>
    </span>
  </router-link>

  <button
    v-else-if="routine"
    :class="[
      'button',
      { 'button--round': round },
      { 'button--red': red },
      { 'button--white': white },
      { 'button--disabled': disabled },
      { 'button--large': large },
      { 'button--full': full },
      { 'button--icon': icon },
      { 'button--overlay': overlay },
      { 'button--border': border },
      { 'button--simple': simple }
    ]"
    @click="routine"
  >
    <span>
      <slot />
      <span
        v-if="text"
        class="button__text"
      >
        {{ text }}
      </span>
    </span>
  </button>

  <button
    v-else
    :class="[
      'button',
      { 'button--round': round },
      { 'button--red': red },
      { 'button--white': white },
      { 'button--disabled': disabled },
      { 'button--large': large },
      { 'button--full': full },
      { 'button--icon': icon },
      { 'button--overlay': overlay },
      { 'button--border': border },
      { 'button--simple': simple }
    ]"
    type="submit"
  >
    <span>
      <slot />
      <span
        v-if="text"
        class="button__text"
      >
        {{ text }}
      </span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'Button',

  props: {
    text: String,
    disabled: Boolean,
    large: Boolean,
    full: Boolean,
    round: Boolean,
    red: Boolean,
    white: Boolean,
    icon: Boolean,
    overlay: Boolean,
    border: Boolean,
    simple: Boolean,
    link: String,
    route: String,
    routine: Function
  }
}
</script>

<style lang="scss" scoped>
$min-width-button: 130px;
$color-white-alpha-15: rgba(255, 255, 255, 0.15);

.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: $min-width-button;
  margin: 0;
  padding: $spacer-unit $spacer-unit-x4;
  overflow: visible;
  color: $white;
  font: inherit;
  font-weight: $font-weight-bold;
  line-height: 1;
  background-color: $blue;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border: none;
  border-radius: $border-radius-default-x2;
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;

  &::after {
    @include size(100%);

    position: absolute;
    top: 0;
    left: 0;
    background-image: linear-gradient(
      to bottom,
      $color-white-alpha-15,
      transparent
    );
    border-radius: $border-radius-default-x2;
    content: '';
  }

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &--simple {
    display: inline-flex;
    padding: 0;
    background: none;
    border-radius: 0;

    .button__text {
      color: $blue;
    }
  }

  &--red {
    background-color: $red;

    &.button--simple {
      background-color: transparent;

      .button__text {
        color: $red;
      }
    }
  }

  &--white {
    background-color: $white;

    .button__text {
      color: $blue;
    }
  }

  &--disabled {
    background-color: $grey-light;
    opacity: 0.5;
    pointer-events: none;

    &:hover {
      color: initial;
    }
  }

  &--large {
    padding: 12px 72px;
  }

  &--full {
    width: 100%;
  }

  &--icon {
    display: inline-flex;
    justify-content: space-between;
    padding: 0;
    color: $grey;
    background-color: transparent;

    span {
      width: inherit;
    }

    .button__text {
      margin-left: $spacer-unit;
    }
  }

  &--round {
    padding: $spacer-unit $spacer-unit-x4;
    border-radius: $border-radius-default-x2;
  }

  &--overlay {
    position: relative;
    overflow: hidden;
  }

  &--border {
    position: relative;
    padding: 6px 0;
    background-image: url('../assets/svg/divider.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 100% 1px;
  }

  &.button--white,
  &.button--simple,
  &.button--icon {
    &::after {
      display: none;
    }
  }

  &.button--simple,
  &.button--icon {
    min-width: auto;
  }
}
</style>
